import { JSONSchema7 } from 'json-schema';
import ControlKind from '../controlKind';
import ControlState from '../controlState';
import JSONSchema7Properties from '../jSONSchema7Properties';

export default (pageId: string, pageSchema: JSONSchema7): ControlState[] => {
  const pageProperties = pageSchema.properties as JSONSchema7Properties;
  const controls = Object.getOwnPropertyNames(pageProperties).map(
    (propName: string) => {
      const controlSchema = pageProperties[propName] as JSONSchema7;
      const controlProperties =
        controlSchema.properties as JSONSchema7Properties;
      const controlKind = controlProperties['type'].default as ControlKind;
      const isConditional = controlProperties['conditional']
        ?.default as boolean;
      return {
        id: controlSchema.$id?.split('/')[1] as string,
        pageId: pageId,
        building: false,
        schema: controlSchema,
        kind: controlKind,
        visible: !isConditional
      } as ControlState;
    }
  );
  return controls;
};
